// ** Logo
import { useEffect, useState } from 'react'
import classnames from 'classnames'

const SplashScreen = () => {
    const [show, setShow] = useState(true)
    const [showLeaves, setShowLeaves] = useState(false)

    useEffect(() => {        
        setTimeout(() => { setShowLeaves(true) }, 1000)
        setTimeout(() => { setShow(false) }, 6000)
    }, [])

    return (
        <>
            {show &&
                <div className="fallback-spinner vh-100">                    
                    <svg viewBox="0 0 18 18" className={classnames('svg-straight', {'svg-straight-normal': showLeaves})}>
                        <defs>
                            <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stopColor="#05a" />
                                <stop offset="100%" stopColor="#0a5" />
                            </linearGradient>
                        </defs>
                        <path className="path" fill="url(#gradient1)" d="M16.8,1.5c0-0.8-0.7-1.2-1.4-0.9c-0.3,0.1-0.5,0.2-0.8,0.3c-1.3,0.5-2.7,0.9-4.1,1.2C9.3,2.3,6.3,2.2,4.3,4.2 C2.1,6.4,1.8,9.9,3,12.7C3,12.9,3,13,2.9,13.2c-0.6,1-1,1.8-1.4,2.8c-0.2,0.5,0,0.9,0.5,1.1c0.4,0.1,0.3,0.2,0.7,0.3c0.5,0.2,0.9,0,1.1-0.5C4.1,15.9,4.5,15,5,14.2C5.1,14,5.2,14,5.4,14c1.6,0.5,3.4,0.7,4.9,0.2c2.9-0.9,4.9-2.8,5.8-5.8C17.1,5.7,16.8,2.1,16.8,1.5z M7.4,10.4c-1.5,2.1-2.5,2-2.5,1.5c0-1.9,2.7-4.3,6.2-5.3C11.1,6.6,9.3,7.8,7.4,10.4z"/>
                    </svg>
                    <svg className={classnames('svg-leaf-left', {'svg-leaf-normal': showLeaves})} viewBox="0 0 500 500">
                        <defs>
                            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stopColor="#05a" />
                                <stop offset="100%" stopColor="#0a5" />
                            </linearGradient>
                        </defs>
                        <path className="path" fill="url(#gradient)" stroke="#05a" strokeWidth="4" d="M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.2 5.4c-25.9 5.9-50 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"/>
                    </svg>
                    <svg className={classnames('svg-leaf-right', {'svg-flip': showLeaves})} viewBox="0 0 500 500">
                        <defs>
                            <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stopColor="#05a" />
                                <stop offset="100%" stopColor="#0a5" />
                            </linearGradient>
                        </defs>
                        <path className="path" fill="url(#gradient2)" stroke="#05a" strokeWidth="4" d="M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.2 5.4c-25.9 5.9-50 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"/>
                    </svg>
                    
                    <svg className='svg-txt'>
                            <defs>
                                {/* <pattern id="polka-dots" x="0" y="0" width="100" height="100"
                                    patternUnits="userSpaceOnUse">
                                    <circle fill="#be9ddf" cx="25" cy="25" r="3"></circle>
                                </pattern> */}
                                <style>
                                    @import url("https://fonts.googleapis.com/css?family=Lora:400,400i,700,700i");
                                </style>
                            </defs>
                            <rect x="0" y="0" width="100%" height="100%" fill="url(#polka-dots)"> </rect>
                            <text x="50%" y="85%" textAnchor="middle" className='text-anim' >
                                ESG TBA
                            </text>
                        </svg>
                    {/* <div className="loading">
        <div className="effect-1 effects"></div>
        <div className="effect-2 effects"></div>
        <div className="effect-3 effects"></div>
      </div> */}
                </div>}
        </>
    )
}

export default SplashScreen
